import React, { Component } from "react";

/// Link
import { Link } from "react-router-dom";

/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";

/// Menu
import MetisMenu from "metismenujs";
import { withTranslation } from "react-i18next";
import { ThemeContext } from "../../../context/ThemeContext";

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el, { toggle: false });
  }
  componentWillUnmount() {
    //  this.mm("dispose");
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

class SideBar extends Component {
  static contextType = ThemeContext;

  constructor(props) {
    super(props);
    this.state = {
      render: false,
      toggle: false
    };
  }
  componentDidMount() {
    const _this = this;
    // sidebar open/close
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");

    function toggleFunc() {
      
      _this.setState({
        toggle: !_this.state.toggle
      });

      return aaa.classList.toggle("menu-toggle");
    }

    btn.addEventListener("click", toggleFunc);
  }

  onClickRender(_this) {
    _this.setState({
      render: !_this.state.render,
    });
  }

  render() {
    const { t } = this.props;
    const { menus } = this.context;
    const { toggle } = this.state;

    const ml = toggle ? "" : " ml-2";

    let _this = this;
    /// Path
    let path = window.location.pathname;
    if (decodeURIComponent(path).includes("arşiv") || decodeURIComponent(path).includes("raporlar")) {
      path = path.split("/");
      path = path[path.length - 2] + "/" +path[path.length - 1];
    } else {
      path = path.split("/");
      path = path[path.length - 1];
    }

    if (decodeURIComponent(path).includes('bilgi-bankasi-kategori')) {
      path += window.location.search;
    }

    return (
      <div className="deznav">
        {menus.length > 0 && (
          <PerfectScrollbar className="deznav-scroll">
            <MM className="metismenu" id="menu">
              {menus.map((m, mapIndex) => {
                if (m.label == "ANASAYFA" || m.label == "Mevcut Kayıtları Düzenle" ) {
                  return (
                    <li key={mapIndex}>
                      <Link
                        // className="has-arrow ai-icon"
                        to={m.url}
                        aria-expanded="false"
                        className={`${
                          m.children
                            ? m.children.findIndex(
                                (c) => c.url == "/" + decodeURIComponent(path)
                              ) != -1
                              ? "menu-active"
                              : ""
                            : ""
                        }`}
                      >
                        <i className={m.icon + ml}></i>
                        <span className="nav-text">{t(m.title)}</span>
                      </Link>
                    </li>
                  );
                } else {
                  return (
                    <li
                      key={mapIndex}
                    // className={}
                    >
                      <Link
                        className={
                          "has-arrow ai-icon " +
                          `${
                            m.children
                              ? m.children.findIndex(
                                  (c) => c.url == decodeURIComponent(path) || c.url == "/" + decodeURIComponent(path)
                                ) != -1
                                ? "menu-active"
                                : ""
                              : ""
                          }`
                        }
                        to="#"
                        aria-expanded="false"
                        onClick={() => this.onClickRender(_this)}
                      >
                        <i className={m.icon + ml}></i>
                        <span className="nav-text">{t(m.label)}</span>
                      </Link>
                      {m.children && (
                        <ul aria-expanded="false">
                          { m.children
                            .filter(a => a.title != null && a.url != null)
                            .sort((a,b) => (a.menuOrder > b.menuOrder) ? 1 : ((b.menuOrder > a.menuOrder) ? -1 : 0))
                            .map((c, mapIndex) => {
                            return (
                              <li key={mapIndex}>
                                <Link
                                  className={`${
                                    "/" + decodeURIComponent(path) === c.url || decodeURIComponent(path) === c.url
                                      ? "submenu-active"
                                      : ""
                                  }`}
                                  to={c.url}
                                  onClick={() => this.onClickRender(_this)}
                                >
                                  {t(c.title)}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </li>
                  );
                }
              })}
            </MM>
          </PerfectScrollbar>
        )}
      </div>
    );
  }
}

export default withTranslation()(SideBar);
